// extracted by mini-css-extract-plugin
module.exports = {"navCollapsed":"NavItem_navCollapsed__3yv02","navLink":"NavItem_navLink__1bQUg","selected":"NavItem_selected__3H9zF","navIconCollapsed":"NavItem_navIconCollapsed__2Ab_4"};